import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import type { Methodology } from '../../types'
import * as enums from '../enums'

const DOC = gql`
  mutation UpdateSpaceRecordFunctionalUsageLite(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $scenarioId: ID!
    $spaceRecordId: ID!
    $update: SpaceRecordFunctionalUsageUpdate!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            extra {
              space {
                updateSpaceRecordFunctionalUsage(
                  spaceRecordId: $spaceRecordId
                  update: $update
                ) {
                  functionalizationMethodology
                }
              }
            }
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.select<
  graphql.schema.UpdateSpaceRecordFunctionalUsageLiteMutation,
  Methodology | undefined,
  'tenant'
>(
  'tenant',
  graphql.transformers.OUT.select(
    'zone',
    graphql.transformers.OUT.select(
      'app',
      graphql.transformers.OUT.select(
        'scenario',
        graphql.transformers.OUT.select(
          'extra',
          graphql.transformers.OUT.select(
            'space',
            graphql.transformers.OUT.select(
              'updateSpaceRecordFunctionalUsage',
              graphql.transformers.OUT.select(
                'functionalizationMethodology',
                enums.SPACE_RECORD_FUNCTIONAL_METHODOLOGY,
              ),
            ),
          ),
        ),
      ),
    ),
  ),
)

export const executor = graphql.createExecutor<
  graphql.schema.UpdateSpaceRecordFunctionalUsageLiteMutation,
  Methodology | undefined,
  graphql.schema.UpdateSpaceRecordFunctionalUsageLiteMutationVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
